import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const domNode = document.getElementById('project-map');
const root = createRoot(domNode);
const copy = document.getElementById('project-map-content')?.innerHTML || false;

root.render(
    <App copy={copy} />
);
